<div class="row">
  <div class="col-sm-12">
    <label>{{ label }} *</label>
    <ckeditor [(ngModel)]="value" [config]="ckEditorConfig" (change)="onInput($event)"> </ckeditor>
  </div>
</div>
